import DataQuery from "../components/DataQuery/DataQuery";
import StartingPageContent from "../components/StartingPage/StartingPageContent";
const DataQueryPage = () => {
  return (
    <StartingPageContent pageName="Konfiguro Kërkesa">
      <DataQuery></DataQuery>
    </StartingPageContent>
  );
};

export default DataQueryPage;
